import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { en, de, nl } from './translations';

const resources = {
  en,
  de,
  nl,
};

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: localStorage.getItem('lng') || 'en',
  resources,
  bindI18n: 'languageChanged',
});

export const t = i18n.t;
export default i18n;
